import { render, staticRenderFns } from "./StreakCount.vue?vue&type=template&id=03d402cd&scoped=true&"
import script from "./StreakCount.vue?vue&type=script&lang=ts&"
export * from "./StreakCount.vue?vue&type=script&lang=ts&"
import style0 from "./StreakCount.vue?vue&type=style&index=0&id=03d402cd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d402cd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('03d402cd', component.options)
    } else {
      api.reload('03d402cd', component.options)
    }
    module.hot.accept("./StreakCount.vue?vue&type=template&id=03d402cd&scoped=true&", function () {
      api.rerender('03d402cd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/userhome/components/StreakCount.vue"
export default component.exports